(function () {
  if (window.__lolaBuscador) return;
  window.__lolaBuscador = true;

  function iniciar(panel) {
    var id = panel.getAttribute('data-lola');
    var caja = panel.querySelector('.lola-sug__filtros');
    var boton = panel.querySelector('.lola-sug__ver');
    var limpiar = panel.querySelector('.lola-sug__limpiar');
    var grid = panel.querySelector('.lola-sug__prods');
    var titulo = panel.querySelector('.lola-sug__label--prods');
    var vacio = panel.querySelector('.lola-sug__vacio');
    var urlTodos = panel.getAttribute('data-lola-todos');
    var urlBuscar = panel.getAttribute('data-lola-buscar');
    if (!caja || !boton || !grid || !titulo) return;

    var gridInicial = grid.innerHTML;
    var tituloInicial = titulo.textContent;
    var botonInicial = boton.textContent;
    var reloj = null;
    var turno = 0;

    function parametros() {
      var p = new URLSearchParams();
      var min = document.getElementById(id + '-min');
      var max = document.getElementById(id + '-max');
      if (min && min.value) p.append('filter.v.price.gte', min.value);
      if (max && max.value) p.append('filter.v.price.lte', max.value);
      Array.prototype.forEach.call(
        caja.querySelectorAll('input[name="filter.p.tag"]:checked'),
        function (c) { p.append('filter.p.tag', c.value); }
      );
      return p;
    }

    function consulta() {
      var campo = document.getElementById(id);
      return campo && campo.value ? campo.value.trim() : '';
    }

    function pintar(lista) {
      grid.textContent = '';
      lista.forEach(function (p) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'lola-sug__p';
        a.href = p.url;

        var cajaImg = document.createElement('span');
        cajaImg.className = 'lola-sug__p-img';
        if (p.img) {
          var img = document.createElement('img');
          img.src = p.img;
          img.width = 300;
          img.height = 300;
          img.loading = 'lazy';
          img.alt = '';
          cajaImg.appendChild(img);
        }

        var t = document.createElement('span');
        t.className = 'lola-sug__p-t';
        t.textContent = p.titulo;

        var pr = document.createElement('span');
        pr.className = 'lola-sug__p-pr';
        if (p.antes) {
          var s = document.createElement('s');
          s.textContent = p.antes;
          pr.appendChild(s);
        }
        var b = document.createElement('b');
        b.textContent = p.precio;
        pr.appendChild(b);

        a.appendChild(cajaImg);
        a.appendChild(t);
        a.appendChild(pr);
        li.appendChild(a);
        grid.appendChild(li);
      });
    }

    function restaurar() {
      turno = turno + 1;
      panel.classList.remove('lola-sug--cargando');
      grid.innerHTML = gridInicial;
      titulo.textContent = tituloInicial;
      if (vacio) vacio.hidden = true;
      if (limpiar) limpiar.hidden = true;
      boton.hidden = false;
      boton.textContent = botonInicial;
    }

    function actualizar() {
      var p = parametros();
      var cadena = p.toString();
      if (!cadena) { restaurar(); return; }

      var mio = turno + 1;
      turno = mio;
      panel.classList.add('lola-sug--cargando');
      if (limpiar) limpiar.hidden = false;

      fetch(urlTodos + '?' + cadena + '&sort_by=best-selling&view=lolajson')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (mio !== turno) return;
          panel.classList.remove('lola-sug--cargando');
          if (!d || typeof d.total !== 'number') { restaurar(); return; }
          if (d.total === 0) {
            grid.textContent = '';
            titulo.textContent = 'Sin resultados';
            if (vacio) vacio.hidden = false;
            boton.hidden = true;
            return;
          }
          if (vacio) vacio.hidden = true;
          boton.hidden = false;
          pintar(d.productos || []);
          titulo.textContent = d.total === 1 ? '1 producto' : d.total + ' productos';
          boton.textContent = d.total === 1 ? 'Ver el producto' : 'Ver los ' + d.total + ' productos';
        })
        .catch(function () {
          if (mio !== turno) return;
          panel.classList.remove('lola-sug--cargando');
          restaurar();
        });
    }

    function programar() {
      clearTimeout(reloj);
      reloj = setTimeout(actualizar, 350);
    }

    caja.addEventListener('change', programar);
    caja.addEventListener('input', programar);

    if (limpiar) {
      limpiar.addEventListener('click', function () {
        var min = document.getElementById(id + '-min');
        var max = document.getElementById(id + '-max');
        if (min) min.value = '';
        if (max) max.value = '';
        Array.prototype.forEach.call(
          caja.querySelectorAll('input[name="filter.p.tag"]'),
          function (c) { c.checked = false; }
        );
        restaurar();
      });
    }

    boton.addEventListener('click', function () {
      var p = parametros();
      var q = consulta();
      var base;
      if (q) {
        p.append('q', q);
        p.append('options[prefix]', 'last');
        base = urlBuscar;
      } else {
        base = urlTodos;
      }
      var cadena = p.toString();
      window.location.href = cadena ? base + '?' + cadena : base;
    });

    var chat = panel.querySelector('.lola-sug__chat');
    if (chat) {
      chat.addEventListener('click', function () {
        var cajon = chat.closest('details-modal');
        var det = cajon ? cajon.querySelector('details') : null;
        if (det) det.open = false;
        var intentos = 0;
        (function abrir() {
          var w = document.querySelector('shopify-chat');
          var act = w && w.shadowRoot ? w.shadowRoot.querySelector('.activator') : null;
          if (act) { act.click(); return; }
          intentos = intentos + 1;
          if (intentos < 15) { setTimeout(abrir, 200); return; }
          window.location.href = panel.getAttribute('data-lola-contacto');
        })();
      });
    }
  }

  function arrancar() {
    Array.prototype.forEach.call(document.querySelectorAll('.lola-sug[data-lola]'), iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();